(function () {
  "use strict";

  var DEFAULT_TRANSLATIONS = {
    pageTitle: "Localiza tu pedido",
    orderInputPlaceholder: "9607",
    orderPrefix: "CDF-",
    orderLabel: "Numero de pedido",
    emailLabel: "Email utilizado para hacer la compra",
    subheading: "Introduce tu numero de pedido y el email utilizado para hacer la compra.",
    emailInputPlaceholder: "Email utilizado para hacer la compra",
    submitButton: "Localizar pedido",
    submitButtonLoading: "Localizando...",
    loadingMessage: "Estamos consultando el seguimiento de tu pedido.",
    emptyFieldsError: "Introduce el numero de pedido y el email utilizado para hacer la compra.",
    notFoundError: "No hemos podido encontrar un pedido con esos datos.",
    genericError: "No se pudo consultar el seguimiento en este momento.",
    trackingInfoTitle: "Informacion de seguimiento",
    orderInfoTitle: "Informacion del pedido",
    carrierLabel: "Transportista",
    trackingNumberLabel: "Numero de seguimiento",
    orderNumberLabel: "Numero de pedido",
    packageLabel: "Paquete",
    noEvents: "Todavia no hay eventos disponibles.",
    noProducts: "No hay productos asociados a este paquete.",
    showMore: "Mostrar mas",
    showLess: "Mostrar menos",
    deliveredPackagesText: "{delivered} de {total} paquetes entregados.",
    latestUpdateLabel: "Ultima actualizacion",
    deliveryTimeLabel: "Hora de entrega"
  };

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function escapeAttribute(value) {
    return escapeHtml(value);
  }

  function normalizeApiBase(value) {
    return String(value || "").trim().replace(/\/+$/, "");
  }

  function buildUrl(base, path) {
    return normalizeApiBase(base) + path;
  }

  function normalizeShopRoot(value) {
    var root = String(value || "/").trim();
    if (!root) return "/";
    return "/" + root.replace(/^\/+|\/+$/g, "") + "/";
  }

  function buildStorefrontUrl(path, shopRoot) {
    var cleanPath = String(path || "").trim();
    if (!cleanPath) return "";
    if (/^https?:\/\//i.test(cleanPath)) return cleanPath;
    return normalizeShopRoot(shopRoot) + cleanPath.replace(/^\/+/, "");
  }

  function getValue(object, path, fallback) {
    var current = object;
    for (var index = 0; index < path.length; index += 1) {
      if (!current || typeof current !== "object") return fallback;
      current = current[path[index]];
    }
    return current === undefined || current === null ? fallback : current;
  }

  function showMessage(elements, text, type) {
    if (!elements.message) return;

    elements.message.textContent = text || "";
    elements.message.classList.remove("is-error", "is-info");

    if (text) {
      elements.message.classList.add(type === "error" ? "is-error" : "is-info");
    }
  }

  function setLoading(elements, loading, translations) {
    if (!elements.submit) return;

    elements.submit.disabled = Boolean(loading);
    elements.submit.textContent = loading
      ? translations.submitButtonLoading || DEFAULT_TRANSLATIONS.submitButtonLoading
      : translations.submitButton || DEFAULT_TRANSLATIONS.submitButton;
  }

  function getTrimmedInput(input) {
    return input ? String(input.value || "").trim() : "";
  }

  function applyTranslations(root, translations) {
    var prefix = root.querySelector("[data-cdf-order-prefix]");
    var emailInput = root.querySelector("[data-cdf-email-input]");
    var emailLabel = root.querySelector("[data-cdf-email-label]");
    var submit = root.querySelector("[data-cdf-submit]");
    var trackingInfoTitle = root.querySelector("[data-cdf-tracking-info-title]");
    var orderInfoTitle = root.querySelector("[data-cdf-order-info-title]");

    Array.prototype.forEach.call(root.querySelectorAll("[data-cdf-i18n]"), function (element) {
      var key = element.getAttribute("data-cdf-i18n") || "";
      var value = translations[key] || DEFAULT_TRANSLATIONS[key] || "";
      if (value) element.textContent = value;
    });

    if (prefix) prefix.textContent = translations.orderPrefix || DEFAULT_TRANSLATIONS.orderPrefix;
    if (emailLabel) emailLabel.textContent = translations.emailLabel || translations.emailInputPlaceholder || DEFAULT_TRANSLATIONS.emailLabel || DEFAULT_TRANSLATIONS.emailInputPlaceholder;
    if (emailInput) {
      emailInput.placeholder = translations.emailInputPlaceholder || DEFAULT_TRANSLATIONS.emailInputPlaceholder;
      emailInput.setAttribute("aria-label", translations.emailLabel || translations.emailInputPlaceholder || DEFAULT_TRANSLATIONS.emailLabel || DEFAULT_TRANSLATIONS.emailInputPlaceholder);
    }
    if (submit) submit.textContent = translations.submitButton || DEFAULT_TRANSLATIONS.submitButton;
    if (trackingInfoTitle) trackingInfoTitle.textContent = translations.trackingInfoTitle || DEFAULT_TRANSLATIONS.trackingInfoTitle;
    if (orderInfoTitle) orderInfoTitle.textContent = translations.orderInfoTitle || DEFAULT_TRANSLATIONS.orderInfoTitle;
  }

  function formatMoney(amount, currencyCode) {
    var number = Number(amount || 0);

    if (!number || Number.isNaN(number)) return "";

    try {
      return new Intl.NumberFormat("es-ES", {
        style: "currency",
        currency: currencyCode || "EUR"
      }).format(number);
    } catch (_error) {
      return number.toFixed(2) + " " + (currencyCode || "EUR");
    }
  }

  function formatDateTime(value) {
    var text = String(value || "").trim();
    if (!text) return "";
    return text;
  }

  function makePackageLabel(index, pkg, translations) {
    var label = translations.packageLabel || DEFAULT_TRANSLATIONS.packageLabel || "Paquete";
    var tracking = pkg && pkg.trackingNumberMasked ? " · " + pkg.trackingNumberMasked : "";
    return label + " n\u00ba" + (index + 1) + tracking;
  }

  function renderInfoRow(label, value) {
    if (!value) return "";

    return [
      '<div class="cdf-tracking-info-row">',
      '<div class="cdf-tracking-info-label">' + escapeHtml(label) + '</div>',
      '<div class="cdf-tracking-info-value">' + escapeHtml(value) + '</div>',
      '</div>'
    ].join("");
  }

  function renderOrderInfo(response, pkg, translations) {
    var rows = "";

    rows += renderInfoRow(
      translations.orderNumberLabel || DEFAULT_TRANSLATIONS.orderNumberLabel,
      response.orderName || response.normalizedOrderName || ""
    );

    rows += renderInfoRow(
      translations.carrierLabel || DEFAULT_TRANSLATIONS.carrierLabel,
      pkg && pkg.company ? pkg.company : ""
    );

    rows += renderInfoRow(
      translations.trackingNumberLabel || DEFAULT_TRANSLATIONS.trackingNumberLabel,
      pkg && pkg.trackingNumberMasked ? pkg.trackingNumberMasked : ""
    );

    var latestUpdate = getValue(pkg, ["latestStatus", "dateTime"], "");
    rows += renderInfoRow(
      translations.latestUpdateLabel || DEFAULT_TRANSLATIONS.latestUpdateLabel,
      formatDateTime(latestUpdate)
    );

    return rows;
  }

  function renderTimeline(pkg, translations) {
    var events = pkg && Array.isArray(pkg.events) ? pkg.events : [];

    if (!events.length) {
      return '<p class="cdf-tracking-empty">' + escapeHtml(translations.noEvents || DEFAULT_TRANSLATIONS.noEvents) + '</p>';
    }

    return events
      .map(function (event) {
        var title = event.publicTextEs || event.labelEs || "";
        var date = event.estimatedDateEs || event.dateTime || "";

        return [
          '<div class="cdf-tracking-event">',
          '<span class="cdf-tracking-dot" aria-hidden="true"></span>',
          '<div class="cdf-tracking-event-title">' + escapeHtml(title) + '</div>',
          date ? '<div class="cdf-tracking-event-date">' + escapeHtml(formatDateTime(date)) + '</div>' : "",
          '</div>'
        ].join("");
      })
      .join("");
  }

  function renderProductCard(item, shopRoot) {
    var title = item && item.title ? item.title : "";
    var variant = item && item.variantTitle ? item.variantTitle : "";
    var quantity = Number(item && item.quantity ? item.quantity : 1);
    var imageUrl = item && item.imageUrl ? item.imageUrl : "";
    var productUrl = buildStorefrontUrl(
      item && item.productUrl ? item.productUrl : "",
      shopRoot
    );
    var currency = item && item.currencyCode ? item.currencyCode : "EUR";
    var unitPrice = formatMoney(item && item.unitPrice ? item.unitPrice : "", currency);
    var compareAtPrice = "";

    if (
      item &&
      item.compareAtPrice &&
      item.unitPrice &&
      Number(item.compareAtPrice) > Number(item.unitPrice)
    ) {
      compareAtPrice = formatMoney(item.compareAtPrice, currency);
    }

    var imageHtml = imageUrl
      ? '<img class="cdf-tracking-product-card__image" src="' + escapeAttribute(imageUrl) + '" alt="' + escapeAttribute(title) + '" loading="lazy">'
      : '<div class="cdf-tracking-product-card__image cdf-tracking-product-card__image--empty"></div>';

    var mediaHtml = productUrl
      ? '<a class="cdf-tracking-product-card__media" href="' + escapeAttribute(productUrl) + '">' + imageHtml + '</a>'
      : '<div class="cdf-tracking-product-card__media">' + imageHtml + '</div>';

    var titleHtml = productUrl
      ? '<a class="cdf-tracking-product-card__title" href="' + escapeAttribute(productUrl) + '">' + escapeHtml(title) + '</a>'
      : '<span class="cdf-tracking-product-card__title">' + escapeHtml(title) + '</span>';

    var variantHtml = variant
      ? escapeHtml(variant) + " \u00d7 " + escapeHtml(String(quantity))
      : "Cantidad \u00d7 " + escapeHtml(String(quantity));

    return [
      '<article class="cdf-tracking-product-card">',
      mediaHtml,
      '<div class="cdf-tracking-product-card__content">',
      titleHtml,
      '<div class="cdf-tracking-product-card__variant">' + variantHtml + '</div>',
      '</div>',
      '<div class="cdf-tracking-product-card__prices">',
      unitPrice ? '<div class="cdf-tracking-product-card__price">' + escapeHtml(unitPrice) + '</div>' : "",
      compareAtPrice ? '<div class="cdf-tracking-product-card__compare">' + escapeHtml(compareAtPrice) + '</div>' : "",
      '</div>',
      '</article>'
    ].join("");
  }

  function renderProducts(pkg, translations, shopRoot) {
    var items = pkg && Array.isArray(pkg.items) ? pkg.items : [];

    if (!items.length) {
      return '<p class="cdf-tracking-empty">' + escapeHtml(translations.noProducts || DEFAULT_TRANSLATIONS.noProducts) + '</p>';
    }

    return items
      .map(function (item) {
        return renderProductCard(item, shopRoot);
      })
      .join("");
  }

  function renderPackageTabs(elements, response, activeIndex, translations, onSelectPackage) {
    var packages = Array.isArray(response.packages) ? response.packages : [];

    elements.packageTabs.innerHTML = packages
      .map(function (pkg, index) {
        var activeClass = index === activeIndex ? " is-active" : "";
        return [
          '<button type="button" class="cdf-tracking-tab' + activeClass + '" data-cdf-package-index="' + index + '">',
          escapeHtml(makePackageLabel(index, pkg, translations)),
          '</button>'
        ].join("");
      })
      .join("");

    Array.prototype.forEach.call(
      elements.packageTabs.querySelectorAll("[data-cdf-package-index]"),
      function (button) {
        button.addEventListener("click", function () {
          var index = Number(button.getAttribute("data-cdf-package-index") || 0);
          onSelectPackage(index);
        });
      }
    );
  }

  function renderResponse(elements, response, translations, shopRoot) {
    var activePackageIndex = 0;
    var packages = Array.isArray(response.packages) ? response.packages : [];
    var summary = response.orderSummary || {};

    function renderActivePackage(index) {
      activePackageIndex = index;
      var pkg = packages[activePackageIndex] || null;

      renderPackageTabs(elements, response, activePackageIndex, translations, renderActivePackage);

      if (elements.timeline) {
        elements.timeline.innerHTML = renderTimeline(pkg, translations);
      }

      if (elements.orderInfo) {
        elements.orderInfo.innerHTML = renderOrderInfo(response, pkg, translations);
      }

      if (elements.products) {
        elements.products.innerHTML = renderProducts(pkg, translations, shopRoot);
      }
    }

    if (elements.results) {
      elements.results.classList.add("is-visible");
    }

    if (elements.summaryLabel) {
      elements.summaryLabel.textContent = summary.labelEs || "";
    }

    if (elements.summaryTitle) {
      elements.summaryTitle.textContent = summary.publicTitleEs || response.message || "";
    }

    if (elements.summaryPackages) {
      var deliveredText = translations.deliveredPackagesText || DEFAULT_TRANSLATIONS.deliveredPackagesText;
      elements.summaryPackages.textContent = deliveredText
        .replace("{delivered}", String(summary.deliveredPackages || 0))
        .replace("{total}", String(summary.totalPackages || packages.length || 0));
    }

    renderActivePackage(0);
  }

  async function loadTranslations(apiBase, locale) {
    if (!apiBase) return DEFAULT_TRANSLATIONS;

    try {
      var url = buildUrl(apiBase, "/api/tracking-ui-translations?locale=" + encodeURIComponent(locale || "es"));
      var response = await fetch(url, { method: "GET" });
      var data = await response.json();

      if (response.ok && data && data.translations) {
        return Object.assign({}, DEFAULT_TRANSLATIONS, data.translations);
      }
    } catch (_error) {}

    return DEFAULT_TRANSLATIONS;
  }

  async function initSection(root) {
    var apiBase = normalizeApiBase(root.getAttribute("data-api-base") || "");
    var locale = root.getAttribute("data-locale") || "es";
    var shopRoot = root.getAttribute("data-shop-root") || "/";

    var elements = {
      form: root.querySelector("[data-cdf-form]"),
      orderInput: root.querySelector("[data-cdf-order-input]"),
      emailInput: root.querySelector("[data-cdf-email-input]"),
      submit: root.querySelector("[data-cdf-submit]"),
      message: root.querySelector("[data-cdf-message]"),
      results: root.querySelector("[data-cdf-results]"),
      summaryLabel: root.querySelector("[data-cdf-summary-label]"),
      summaryTitle: root.querySelector("[data-cdf-summary-title]"),
      summaryPackages: root.querySelector("[data-cdf-summary-packages]"),
      packageTabs: root.querySelector("[data-cdf-package-tabs]"),
      timeline: root.querySelector("[data-cdf-timeline]"),
      orderInfo: root.querySelector("[data-cdf-order-info]"),
      products: root.querySelector("[data-cdf-products]")
    };

    var translations = await loadTranslations(apiBase, locale);
    applyTranslations(root, translations);

    if (!elements.form) return;

    elements.form.addEventListener("submit", async function (event) {
      event.preventDefault();

      var order = getTrimmedInput(elements.orderInput);
      var email = getTrimmedInput(elements.emailInput);

      if (!order || !email) {
        showMessage(elements, translations.emptyFieldsError || DEFAULT_TRANSLATIONS.emptyFieldsError, "error");
        return;
      }

      if (!apiBase) {
        showMessage(elements, translations.genericError || DEFAULT_TRANSLATIONS.genericError, "error");
        return;
      }

      showMessage(elements, translations.loadingMessage || DEFAULT_TRANSLATIONS.loadingMessage, "info");
      setLoading(elements, true, translations);

      if (elements.results) {
        elements.results.classList.remove("is-visible");
      }

      try {
        var url =
          buildUrl(apiBase, "/api/tracking") +
          "?order=" + encodeURIComponent(order) +
          "&email=" + encodeURIComponent(email) +
          "&locale=" + encodeURIComponent(locale || "es");

        var response = await fetch(url, { method: "GET" });
        var data = await response.json();

        if (!response.ok || !data || data.ok === false) {
          showMessage(
            elements,
            data && data.message ? data.message : translations.notFoundError || DEFAULT_TRANSLATIONS.notFoundError,
            "error"
          );
          return;
        }

        showMessage(elements, "", "info");
        renderResponse(elements, data, translations, shopRoot);
      } catch (_error) {
        showMessage(elements, translations.genericError || DEFAULT_TRANSLATIONS.genericError, "error");
      } finally {
        setLoading(elements, false, translations);
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    Array.prototype.forEach.call(
      document.querySelectorAll("[data-cdf-order-tracking]"),
      function (root) {
        initSection(root);
      }
    );
  });
})();

